import UserLocaleStorage from '../../services/user-locale-storage';

export function addUserLocaleHeader(config) {
  config.headers['X-User-Locale'] = UserLocaleStorage.getLocale() || 'en';
  return config;
}
